import React, { Fragment } from "react";
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  InputGroup,
  Modal,
  Radio,
} from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import * as Yup from "yup";

import { Input } from "../../FormControls";
import { ExportFormats } from "../../../constant";

import "bootstrap-daterangepicker/daterangepicker.css";
import { FormLabel } from "@material-ui/core";

const initialValues = {
  quantity: "10",
  format: ExportFormats.Pdf.value,
  startDate: moment(),
  purpose: "",
  zipPassword: "",
};

const validationSchema = Yup.object().shape({
  zipPassword: Yup.string().required("Password  is required."),
  quantity: Yup.number().min(1).max(100),
});

export function ExportFormModal({
  show,
  endDate,
  onDateChange,
  onFormSubmit,
  onModalClose,
}) {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onFormSubmit}
    >
      {({ handleSubmit, values, setFieldValue, isSubmitting }) => (
        <Modal
          show={show}
          backdrop="static"
          keyboard={!isSubmitting}
          onHide={onModalClose}
        >
          <Modal.Header>
            <Modal.Title>Export Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form className="form-horizontal">
              <Input
                name="quantity"
                label={{ col: 4, text: "Quantity" }}
                col={8}
                type="number"
              />
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  Validity
                </Col>
                <Col sm={8}>
                  <Field name="startDate">
                    {({ field }) => (
                      <DateRangePicker
                        minDate={values.startDate}
                        startDate={values.startDate}
                        endDate={endDate}
                        onApply={(e, picker) =>
                          onDateChange(e, picker, setFieldValue)
                        }
                        singleDatePicker
                      >
                        <InputGroup>
                          <FormControl
                            value={`${formatDate(field.value)} - ${formatDate(
                              endDate
                            )}`}
                            readOnly
                          />
                          <InputGroup.Addon>
                            <Glyphicon glyph="calendar" />
                          </InputGroup.Addon>
                        </InputGroup>
                      </DateRangePicker>
                    )}
                  </Field>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  Format
                </Col>
                <Col sm={8}>
                  {Object.keys(ExportFormats).map((format) => (
                    <Field key={format} name="format">
                      {({ field }) => (
                        <Radio
                          {...field}
                          checked={
                            Number(field.value) === ExportFormats[format].value
                          }
                          value={ExportFormats[format].value}
                        >
                          {ExportFormats[format].displayName}
                        </Radio>
                      )}
                    </Field>
                  ))}
                </Col>
              </FormGroup>

              <Input
                name="purpose"
                label={{ col: 4, text: "Purpose" }}
                col={8}
                componentClass="textarea"
                rows="3"
              />

              <Input
                name="zipPassword"
                label={{ col: 4, text: "Password" }}
                col={8}
              />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className="btn-toolbar pull-right">
              <button
                className="btn btn-grey"
                disabled={isSubmitting}
                onClick={onModalClose}
              >
                Close
              </button>
              <Button bsStyle="primary" onClick={handleSubmit}>
                Export {isSubmitting && <i className="fa fa-spinner fa-spin" />}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  );
}

function formatDate(date) {
  return moment(date).format("L");
}
